import Image from '../../Atoms/Image';
import svg from '../../../constants/svg';
import aboutBg from '../../../assets/img/about-header-bg.png';
import aboutModel from '../../../assets/img/about-header-model-n.png';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import VideoBox from '../../Molecules/VideoBox';
import BannerCV from '../../Organisms/BannerCV';
import { CardPersonList } from '../../Molecules/CardPerson';

import imgPerson from '../../../assets/img/card-person01.jpg';
import imgPerson2 from '../../../assets/img/card-person02.jpg';
import imgPerson3 from '../../../assets/img/card-person03.jpg';
import DoubleLineText from '../../Atoms/DoubleLineText';
import InViewAnimate from '../../Atoms/InViewAnimate';

function About() {
  return (
    <>
      <section className="relative overflow-hidden bg-sl-blue">
        <Image
          src={aboutBg}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="relative mx-auto w-full max-w-7xl">
          <div className="absolute top-16 -left-28 w-72 sm:top-20 sm:-left-[130px] sm:w-[380px] md:top-32 xl:-top-[30px] xl:-left-[260px] xl:w-[640px]">
            {svg.aboutHeaderDecorLeft}
          </div>
          <div className="absolute -right-72 top-36 w-96 md:-right-20 lg:top-[160px] lg:w-[480px] xl:-right-[358px] xl:w-[800px]">
            {svg.aboutHeaderDecorRight}
          </div>
          <div className="relative z-10 flex min-h-[560px] py-24 px-7 sm:py-36 md:py-40 lg:min-h-[860px] lg:py-52 xl:py-72">
            <div className="relative z-30">
              <Title color="white" as="h2" weight={900}>
                <DoubleLineText
                  lines={[
                    'Maak kennis met',
                    'Synsel Techniek'
                  ]}
                  className="text-3xl xsm:text-5xl xsm:leading-tight sm:text-6xl sm:leading-tight md:text-7xl md:leading-tight xl:text-8xl xl:leading-tight"
                />
              </Title>
            </div>
            <div className="absolute bottom-0 -right-9 h-[65%] xsm:right-0 sm:h-[75%] lg:-mb-10 lg:h-[85%]">
              <Image
                src={aboutModel}
                alt="synsel worker"
                className="h-full"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="pt-16 md:pt-24 xl:pb-40 xl:pt-44">
        <div className="mx-auto mb-10 max-w-7xl px-7 md:mb-16">
          <Text
            font="circular"
            as="p"
            weight={400}
            size="lg"
          >
            Over ons
          </Text>
          <Title weight={900} as="h2">
            <span className="flex flex-col text-2xl xsm:text-4xl md:text-6xl xl:text-[80px]">
              <span>Synsel is ontstaan </span>
              <span>vanuit de techniek!</span>
            </span>
          </Title>
        </div>
        <div className="mx-auto mb-10 max-w-[1656px] px-7 lg:mb-20">
          <div className="flex flex-col justify-end gap-10 md:flex-row-reverse lg:gap-14 xl:gap-28">
            <div className="relative z-10 md:basis-2/5 lg:basis-96">
              <Title
                as="h3"
                size={2}
                weight={900}
                className="mb-5 hidden md:block"
              >
                Over ons
              </Title>
              <Text size="sm" as="div">
                <p>
                  Synsel Techniek is een technisch
                  detacheringsbureau specifiek voor{' '}
                  <a href="/vacatures/#specialismen=monteurs-technische-dienst">
                    monteurs
                  </a>{' '}
                  en{' '}
                  <a href="/vacatures/#specialismen=software-electrical-engineers">
                    engineers
                  </a>
                  . Synsel doet al 10 jaar niks anders dan
                  de beste baan vinden voor technici. Het
                  bedrijf is ontstaan vanuit
                  HR-werkzaamheden die voor de hightech
                  machinebouwer DG Press werden uitgevoerd.
                  Hieruit bleek al snel dat het vinden van
                  goede technici een grote uitdaging is voor
                  bedrijven. Je kan nog zulke mooie
                  innovatieve projecten opstarten, maar
                  zonder de juiste technici wordt een
                  bedrijf geremd in haar groei.
                </p>
              </Text>
            </div>
            <div className="basis md:basis-3/5 lg:basis-[800px]">
              <div className="relative">
                <VideoBox
                  url="https://youtu.be/bq7flHdCsfc"
                  className="relative z-10"
                />
                <div className="absolute -bottom-8 -right-5 z-0 hidden w-32 md:block lg:-right-11 xl:-right-32 xl:w-44">
                  {svg.aboutContentDecor1}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-auto mb-12 max-w-7xl px-7">
          <div className="relative mx-auto max-w-7xl xl:max-w-5xl">
            <div className="grid grid-cols-1 gap-10 lg:gap-12 xl:grid-cols-2 xl:gap-32">
              <div>
                <Title
                  as="h3"
                  size={2}
                  weight={900}
                  className="mb-5"
                >
                  Jij staat centraal
                </Title>
                <Text as="div">
                  <p>
                    Synsel besloot als eerste bureau van
                    Nederland de situatie om te draaien en
                    de kandidaat centraal te zetten. Dit is
                    op de dag van vandaag dé belangrijkste
                    succesfactor van Synsel. De kandidaat
                    staat met zijn of haar wensen en
                    ambities op nummer één. Vanuit deze
                    behoefte worden bedrijven gezocht die
                    het beste passen bij de wensen en
                    ambities van de kandidaat. Want naar een
                    geschikte techneut zijn bedrijven altijd
                    op zoek. Dit heeft ertoe geleid dat
                    Synsel het grootste netwerk van technici
                    heeft binnen de industriële
                    automatisering,{' '}
                    <a href="/vacatures/#specialismen=machinebouwers">
                      machinebouw
                    </a>{' '}
                    en industrie. Inmiddels zijn de ambities
                    van meer dan 1200 technici vervuld en
                    heeft Synsel een netwerk van meer dan
                    2500 bedrijven. Zo weten de adviseurs
                    precies waar technici hun tech dream in
                    vervulling kunnen laten gaan. Het is dan
                    ook de missie van Synsel om zoveel
                    mogelijk monteurs en engineers toegang
                    te geven tot de beste banen.
                  </p>
                </Text>
              </div>
              <div className="relative">
                <Title
                  as="h3"
                  size={2}
                  weight={900}
                  className="mb-5"
                >
                  Business Units
                </Title>
                <Text as="div">
                  <p>
                    In de loop der jaren heeft Synsel zich
                    steeds verder gespecialiseerd binnen de
                    techniek. Dit heeft geleid tot het
                    werken in verschillende businessunits
                    met daarbinnen gespecialiseerde
                    adviseurs, zo kunnen de wensen van
                    kandidaten nog beter vertalen naar
                    concrete functies bij specifieke
                    bedrijven. Hieronder vind je een
                    overzicht van de verschillende
                    businessunits binnen Synsel.
                  </p>
                </Text>
              </div>
            </div>
            <InViewAnimate
              once
              hiddenClass="opacity-0 translate-x-14"
              visibleClass="opacity-100 translate-x-0"
              className="-bottom-32 left-1/2 z-20 w-full duration-1000 ease-[cubic-bezier(0.17,0.55,0.55,1)] xl:absolute xl:w-[730px] 2xl:ml-16 2xl:w-[780px]"
            >
              <BannerCV />
            </InViewAnimate>
            <div className="absolute left-full top-14 ml-6 hidden w-[377px] lg:block">
              {svg.aboutContentDecor2}
            </div>
          </div>
        </div>
      </section>
      <section className="bg-sl-blue py-16 text-white md:py-24 xl:py-32">
        <div className="relative mx-auto max-w-7xl px-7">
          <div className="absolute -left-3 top-36 w-28 md:top-44 md:left-0 md:w-44">
            {svg.aboutContentDecor3}
          </div>
          <div className="mb-10 text-center xsm:mb-20 md:mb-40">
            <Title
              as="h1"
              color="white"
              tracking="tight"
              weight={900}
              className="mb-10"
            >
              <span className="text-6xl leading-none md:text-8xl lg:text-10xl">
                meet the <mark>team</mark>
              </span>
            </Title>
            <Text
              color="white"
              size="lg"
              className="mx-auto max-w-xl"
            >
              With a team of almost 50 colleagues who feel
              like friends, we work hard on great projects
              for the largest companies in the Netherlands.
            </Text>
          </div>
          <div className="grid grid-cols-1 gap-y-20 lg:gap-y-40">
            <div className="-mr-7 lg:-mr-0">
              <Title
                as="h2"
                size={1}
                color="white"
                className="mb-10 lg:mb-20"
              >
                Operators
              </Title>
              <CardPersonList
                list={[
                  {
                    img: { src: imgPerson },
                    title: 'Anne Pelgrum',
                    subtitle: 'Team Lead',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson2 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson3 },
                    title: 'Anne Pelgrum',
                    subtitle:
                      'Manager Candidate Relations and Reactivation',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson2 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson3 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson2 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson3 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  }
                ]}
              />
            </div>
            <div className="-mr-7 lg:-mr-0">
              <Title
                as="h2"
                size={1}
                color="white"
                className="mb-10 lg:mb-20"
              >
                Operators
              </Title>
              <CardPersonList
                list={[
                  {
                    img: { src: imgPerson },
                    title: 'Anne Pelgrum',
                    subtitle: 'Team Lead',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson2 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson3 },
                    title: 'Anne Pelgrum',
                    subtitle:
                      'Manager Candidate Relations and Reactivation',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson2 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson3 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson2 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  },
                  {
                    img: { src: imgPerson3 },
                    title: 'Anne Pelgrum',
                    subtitle: 'Consultant',
                    social: [
                      {
                        icon: 'phone',
                        url: '#!',
                        urlType: 'tel'
                      },
                      { icon: 'linkedin', url: '#!' }
                    ]
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
